const state = { all: {} };
import { apiService } from "@/_services";

const actions = {
  async getAll({ commit }) {
    let params = {
      method: "GET",
      endpoint: "etfs",
      content_type: "application/json",
      query_params: {
        format: "json",
      },
    };
    commit("getAllRequest");
    await apiService
      .getAll(params)
      .then((data) => {
        commit("getAllSuccess", data);
      })
      .catch((error) => {
        console.log(error);
        commit("getAllFailure", error);
      });
  },
  logout({ commit }) {
    commit("logout");
  },
};

const mutations = {
  getAllRequest(state) {
    state.all = { loading: true };
  },
  getAllSuccess(state, etfs) {
    state.all = { items: etfs };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  logout(state) {
    state.all = null;
  },
};

export const etfs = {
  namespaced: true,
  state,
  actions,
  mutations,
};
